// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1nFHQ","approved":"Status_approved__2toq9","rejected":"Status_rejected__vG-kV","expired":"Status_expired__3Ktxl","label":"Status_label__3Id01"};